module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 2
// module chunks = 0